import React, { memo } from 'react'

import { bool } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { parseRunIdFromPathname } from 'Pods/ThreeDStudio/Hooks/parseRunIdFromPathname'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import LoadingBanner from '../LoadingBanner/LoadingBanner'
import CleverPushOptInRow from './Components/CleverPushOptInRow/CleverPushOptInRow'
import RelatedProducts from './Components/RelatedProducts/RelatedProducts'

const GENERATING_TITLE = 'Generating your 3D model'
const GENERATING_DESCRIPTION =
  "This may take a few minutes. You'll see an indicator in the top menu when it's ready. " +
  "We'll also send you an email so you don't miss it."
const SHARED_RUN_TITLE = 'Loading 3D model'

// Picks the loading variant from the URL: a model-detail URL means we're
// hydrating that run ("Loading 3D model"); anything else means the user is
// generating ("Generating your 3D model"). isGenerating takes precedence so
// users who started a generation see the generating copy even though the
// post-completion history.replace will move them onto a model-detail URL.
function LoadingBannerState({ forceSharedRun = false }) {
  const location = useLocation()
  const isGenerating = useThreeDStudioStore(state => state.generation.isGenerating)
  const urlHasModelId = parseRunIdFromPathname(location?.pathname ?? '') != null
  const isSharedRunView = forceSharedRun || (urlHasModelId && !isGenerating)

  return (
    <LoadingBanner
      title={isSharedRunView ? SHARED_RUN_TITLE : GENERATING_TITLE}
      description={isSharedRunView ? null : GENERATING_DESCRIPTION}
      contentChildren={isSharedRunView ? null : <CleverPushOptInRow />}
    >
      {!isSharedRunView && <RelatedProducts />}
    </LoadingBanner>
  )
}

LoadingBannerState.propTypes = {
  forceSharedRun: bool,
}

export default memo(LoadingBannerState)
